import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { useAuthStore } from '../stores';

export interface PrivateRouteProps extends RouteProps {
  redirectTo: string;
}

export const PrivateRoute = ({ component, redirectTo, ...rest }: PrivateRouteProps) => {
  const isAuthenticated = useAuthStore(({ isAuthenticated }) => isAuthenticated);

  return (
    <Route
      {...rest}
      render={(props) => {
        return isAuthenticated ? (
          component ? (
            // TS says that the first param of React.createElement() is missing the history, location and match props
            // that 'component' has, but they are actually not needed by React.createElement() so we ignore the error
            // @ts-ignore
            React.createElement(component, props)
          ) : null
        ) : (
          <Redirect
            to={{
              pathname: redirectTo,
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};
